import { actionable } from '@github/catalyst/lib/actionable'

export default actionable(class extends HTMLElement {
  connectedCallback () {
    this.previousFocus = document.activeElement
    this.setAttribute('role', 'dialog')
    this.setAttribute('aria-modal', 'true')
    const title = this.querySelector('h1,h2,h3,.modal-title')
    if (title) { title.id ||= 'dialog-title-' + Math.random().toString(36).slice(2); this.setAttribute('aria-labelledby', title.id) }
    else { this.setAttribute('aria-label', 'Dialog') }
    this.tabIndex = -1
    requestAnimationFrame(() => {
      if (!this.isConnected) return
      const available = [...this.querySelectorAll('[autofocus],input:not([type=hidden]),textarea,select,button,a[href],[tabindex="0"]')].filter(el => !el.disabled && el.getClientRects().length && !el.closest('[inert]'))
      const target = available.find(el => el.hasAttribute('autofocus')) || available[0]
      ;(target || this).focus()
    })
    this.addEventListener('keydown', this.onTabKey)
    document.body.classList.add('overflow-hidden')

    document.addEventListener('keyup', this.onEscKey)

    document.addEventListener('turbo:before-cache', this.onBeforeCache)

    if (this.dataset.closeAfterSubmit !== 'false') {
      document.addEventListener('turbo:submit-end', this.onSubmit)
    }
  }

  disconnectedCallback () {
    this.removeEventListener('keydown', this.onTabKey)
    if (this.previousFocus?.isConnected) this.previousFocus.focus()
    document.body.classList.remove('overflow-hidden')

    document.removeEventListener('keyup', this.onEscKey)
    document.removeEventListener('turbo:submit-end', this.onSubmit)
    document.removeEventListener('turbo:before-cache', this.onBeforeCache)
  }

  onTabKey = (event) => {
    if (event.key !== 'Tab') return
    const items = [...this.querySelectorAll('a[href],button,input:not([type=hidden]),select,textarea,[tabindex="0"]')].filter(el => !el.disabled && el.getClientRects().length)
    if (!items.length) { event.preventDefault(); this.focus(); return }
    const first = items[0], last = items[items.length - 1]
    if (event.shiftKey && (document.activeElement === first || document.activeElement === this)) { event.preventDefault(); last.focus() }
    else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus() }
  }

  onSubmit = (e) => {
    if (e.detail.success && e.detail?.formSubmission?.formElement?.dataset?.closeOnSubmit !== 'false') {
      this.close()
    }
  }

  onEscKey = (e) => {
    if (e.code === 'Escape') {
      this.close()
    }
  }

  onBeforeCache = () => {
    if (this.closest('turbo-frame')?.src) {
      this.remove()
    }
  }

  close = (e) => {
    e?.preventDefault()

    this.remove()
  }
})
